import { Box, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export const Loading = () => (
  <Box 
    sx={{ width: "100%", height: "50vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }} 
    mt={{xs: 10, md: 12}}
  >
    <CircularProgress color="primary" />
    <Typography variant="h6" mt={2} sx={{ color: "#0E2465" }}>
      Cargando...
    </Typography>
  </Box>
) 